import { useFeature } from "src/core/common/hooks/useFeature";
import FEATURES from "src/core/constants/features";

export const useIsTeamFeatureEnabled = () => useFeature(FEATURES.TEAMS);
